import { ConstrainMode, DetailsListLayoutMode, DetailsRow, IColumn, IDetailsFooterProps, IDetailsListProps, IDetailsListStyles, IDetailsRowStyles, IGroup, IGroupDividerProps, IGroupHeaderProps, IRenderFunction, IStyle, mergeStyleSets, ScrollablePane, ScrollbarVisibility, Selection, SelectionMode, ShimmeredDetailsList, Stack, StackItem, IStackStyles, Label, DetailsHeader, IDetailsRowProps, IDetailsList, ContextualMenu, IContextualMenuProps, DirectionalHint, Point, Sticky, StickyPositionType, IDragDropContext, MarqueeSelection, Spinner, SpinnerSize } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { SearchOpenExtensionHelper } from "../../src/taskpane/components/helpers/SearchOpenExtensionHelper";
import NewFolderPanel from "../../src/taskpane/components/panels/NewFolderPanel";
import { AutomationPanel, IFileApproval } from "../../src/taskpane/components/_v2/components/Panels/AutomationPanel/AutomationPanel";
import { useLazyGetItemWebUrlQuery } from "../../src/taskpane/components/_v2/redux/api/graph/api-graph-slice";
import { useLazyRenderListAsStreamByIDQuery } from "../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { WebPanel } from "../../src/taskpane/components/_v2/_shared/WebPanel/WebPanel";
import { ComponentTypes } from "../../src/taskpane/config/config";
import { displayHeight, OneNoteProgId, rowLockIndicator, SharePointFolderContentTypeIds } from "../../src/taskpane/config/constants";
import { previewWebPanelStyles } from "../../src/taskpane/config/controlStyles";
import { ISearchOpenFileInfo } from "../../src/taskpane/interfaces/ISearchOpenFileInfo";
import authModule from "../../utilities/AuthModule";
import { LanguageContext } from "../../utilities/LocalizationModule";
import { CMCheckinModal } from "../Panels/CMCheckinModal";
import { CMDeleteModal } from "../Panels/CMDeleteModal";
import { CMFileInfoPanel, InfoPanelMode } from "../Panels/CMFileInfoPanel";
import { CMFilePreviewPanel, MoveDirection, SearchSource } from "../Panels/CMFilePreviewPanel";
import { CMRenameModal } from "../Panels/CMRenameModal";
import { CMUploadFilesPanel } from "../Panels/CMUploadFilesPanel";
import { CMVersionHistoryModal } from "../Panels/CMVersionHistoryModal";
import { ContentBodyCommandBar } from "./ContentBodyCommandBar";
import { gridSelectedItems } from "./ContentManagerBody";
import { useContentManagerBody, ViewTypes } from "./useContentManagerBody";
import { useMenuItems } from "./MenuItems/useMenuItems";
import { logger } from "../../utilities/logger";
import { CMErrorModal } from "../Panels/CMErrorModal";
import { CMVersionAppRejModal } from "../Panels/CMVersionAppRejModal";
import { CMFileFilterPanel } from "../Panels/CMFileFilterPanel/CMFileFilterPanel";
import { tryDecodeUriComponent } from "../../utilities/EncodeDecode";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // import plugin
import { useMenuItem_QuickFilter } from "./MenuItems/useMenuItem_QuickFilter";
import { SharePointInputData } from "../../src/taskpane/interfaces/props/SharePointInputData";
import { IFileToUpload } from "../../src/taskpane/interfaces/IFileToUpload";
import { RootState } from "../../src/taskpane/redux";
import { resetContentManagerMoveTo, setContentManagerExchangeProgress, setContentManagerMoveTo, setContentManagerMoveToCopyJobResults, setContentManagerMoveToError, setContentManagerMoveToSelectedFilesIsBusyProgress, setContentManagerSearchValue, toggleContentManagerReload } from "../../src/taskpane/redux/modules/contentManagerDirectory";
import { CMMoveFilesListPanel } from "../Panels/CMMoveFilesListPanel";
import { CMConfirmModal } from "../Panels/CMConfirmModal";
import { ContentManagerCopyMoveModeEnum } from "../../src/taskpane/components/enums/ContentManagerCopyMoveModeEnum";
import { createCopyJobs, getListSettings } from "../../src/taskpane/services/SharePointRestServices";
import { CMFileSharePanel, SharePanelMode } from "../Panels/CMFileSharePanel";
import { CMCancelAssignmentModal } from "../Panels/Nintex/CMCancelAssignmentModal";
import { setLastApprovalLoad } from "../../src/taskpane/redux/modules/approvals";
import { CMDuplicateFileVersionSelectorModal } from "../Panels/CMDuplicateFileVersionSelectorModal";
import { DraggableContainer } from "../../src/taskpane/components/_v2/components/Explorer/FolderView/DraggableContainer";
import { IPageSettings } from "../../src/taskpane/interfaces/IPageSettings";
import { addWorkingDirectory } from "../../src/taskpane/redux/modules/workingDirectory";
import generalModule from "../../utilities/GeneralModule";
import { DragAndDropHelper, DragMode } from "../../utilities/DragAndDropHelper";
import { addUploadedFiles } from "../../src/taskpane/redux/modules/file";
import { getListItemWebUrl } from "../../src/taskpane/services/GraphService";
import { SigningPanel } from "../../src/taskpane/components/_v2/components/Panels/SigningPanel/SigningPanel";
import { BackgroundTaskStatusEnum } from "../../src/taskpane/components/enums/BackgroundTaskStatusEnum";
import { CMFilesUpdatePanel } from "../Panels/CMFilesUpdatePanel";
import { NewDocumentTemplate } from "../../src/taskpane/interfaces/IDocumentTemplate";
import { CMNewLinkPanel } from "../Panels/CMNewLinkPanel";
import { CMFileUploadProgressPanel } from "../Panels/CMFileUploadProgressPanel";
import { ViewTile } from "../../src/taskpane/components/_v2/components/Tile/ViewTile";
const searchIconSrc = require("../../assets/empty_search.svg");
dayjs.extend(utc);

const classNames = {
  row: "listRow",
  optionButton: "listRowOptionButton",
  gripperIcon: "gripperIcon"
};

export const detailsListClassNames = mergeStyleSets({
  wrapper: {
    height: displayHeight,
    position: "relative",
  },

  row: [classNames.row, {}],

  optionButton: [
    classNames.optionButton,
    {
      visibility: "hidden",
      display: "none",
      [`.${classNames.row}:hover &`]: {
        visibility: "visible",
        display: "block",
      },
      [`.${classNames.row}.is-selected &`]: {
        visibility: "visible",
        display: "block",
      },
    },
  ],

  gripperIcon: [
    classNames.gripperIcon,
    {
      visibility: "hidden",
      [`.${classNames.row}:hover &`]: {
        visibility: "visible",
        cursor: "grab"
      },
      [`.${classNames.row}.is-selected &`]: {
        visibility: "visible",
        cursor: "grab"
      },
      [`.${classNames.row}:active &`]: {
        visibility: "visible",
        cursor: "grabbing"
      },
    },
  ],
});

export const detailListStyles: Partial<IDetailsListStyles> = {
  root: {
    margin: "0 0 0 0",
    padding: "0px",
    MsOverflowStyle: "scrollbar"
  },
  headerWrapper: {
    paddingTop: 0
  }
};

const noResultsStackStyles: Partial<IStackStyles> = {
  root: { width: "100%", height: "calc(100vh - 250px)", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

const loadingSpinnerStackStyles: Partial<IStackStyles> = {
  root: { height: 100, width: "100%", margin: 0, padding: 0, overflow: "auto", userSelect: "none" }
};

const headerCountStyle: IStyle = { display: 'none' };

const rowStyles: Partial<IDetailsRowStyles> = {
  cell: {
    display: "inline-flex",
    alignItems: "flex-start"
  },
  checkCell: {
    display: "inline-flex",
    alignItems: "flex-start"
  }
};

export interface IExternalResourceUrl {
  url: string;
  description?: string;
};

export interface IContentBodyFilesFoldersProps {
}

export interface IGridColumn extends IColumn {
  internalName: string;
}

export const ContentBodyFilesFolders = (props: IContentBodyFilesFoldersProps) => {
  const languageStrings = React.useContext(LanguageContext);

  const dispatch = useDispatch();

  const tenantEnablePII = useSelector((state: RootState) => state.user.tenantEnablePII);
  const workingDirectories = useSelector((state: RootState) => state.workingDirectories.workingDirectories);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);
  const oneDriveRootDetails = useSelector((state: RootState) => state.workingDirectories.oneDriveRootDetails);
  const userAccount = useSelector((state: RootState) => state.user.account);
  const isBusySaving = useSelector((state: RootState) => state.savingInBackground.isBusySaving);
  const filterFields = useSelector((state: RootState) => state.contentManagerDirectory.filterFields);
  const moveToEnabled = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.moveToEnabled);
  const moveToDirectory = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.workingDirectories.length > 0 ? state.contentManagerDirectory.moveTo.workingDirectories[state.contentManagerDirectory.moveTo.workingDirectories.length - 1] : null);
  const moveToIsMoveComplete = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.isMoveComplete);
  const moveToMode = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.mode);
  const moveTo = useSelector((state: RootState) => state.contentManagerDirectory.moveTo);
  const moveToSourceServerRelPath = useSelector((state: RootState) => state.contentManagerDirectory.moveTo.sourceServerRelPath);
  const exchangeProgress = useSelector((state: RootState) => state.contentManagerDirectory.exchange.progress);
  const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
  const mode = useSelector((state: RootState) => state.mode.mode);
  const hideAutoPreview = useSelector((state: RootState) => state.tenantInfo?.hideAutoPreview);

  const [selectedItemInfo, setSelectedItemInfo] = React.useState<ISearchOpenFileInfo>(null);
  const [selectedItem, setSelectedItem] = React.useState<any>();
  const [openContextMenu, setOpenContextMenu] = React.useState<boolean>(false);
  const [contextualMenuProps, setContextualMenuProps] = React.useState<IContextualMenuProps>();
  const [selectedItems, setSelectedItems] = React.useState<gridSelectedItems>({ items: [], count: 0 });
  const [selectionCleared, setSelectionCleared] = React.useState<boolean>(false);
  const [waitFor, setWaitFor] = React.useState<boolean>();
  const [waitForContext, setWaitForContext] = React.useState<string>(languageStrings?.LoadingOnly)
  const [isCMCreateFolderPanelOpen, setIsCMCreateFolderPanelOpen] = React.useState(false);
  const [isCMCreateLinkPanelOpen, setIsCMCreateLinkPanelOpen] = React.useState(false);
  const [isCMUploadFilesPanelOpen, setIsCMUploadFilesPanelOpen] = React.useState(false);
  const [showRenameDialog, setShowRenameDialog] = React.useState(false);
  const [isCMFileInfoPanelOpen, setIsCMFileInfoPanelOpen] = React.useState(false);
  const [infoPanelMode, setInfoPanelMode] = React.useState<InfoPanelMode>();
  const [isApprovalsPanelOpen, setIsApprovalsPanelOpen] = React.useState(false);
  const [isSigninPanelOpen, setIsSigningPanelOpen] = React.useState(false);
  const [isFileUploadProgressPanelOpen, setIsFileUploadProgressPanelOpen] = React.useState(false);
  const [approvalFiles, setApprovalFiles] = React.useState<IFileApproval[]>([]);
  const [showDeleteDialog, setShowDeleteDialog] = React.useState(false);
  const [showCancelAssignmentDialog, setShowCancelAssignmentDialog] = React.useState(false);
  const [showVersionHistoryDialog, setShowVersionHistoryDialog] = React.useState(false);
  const [showDuplicateFileVersionSelectorModal, setShowDuplicateFileVersionSelectorModal] = React.useState(false);
  const [isPublish, setIsPublish] = React.useState(false);
  const [showCheckinDialog, setShowCheckinDialog] = React.useState(false);
  const [isCMFilePreviewPanelOpen, setIsCMFilePreviewPanelOpen] = React.useState(false);
  const [isCMVersionAppRejModalOpen, setIsCMVersionAppRejModalOpen] = React.useState(false);
  const [isCMErrorModalOpen, setIsCMErrorModalOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [isCMFileFilterPanelOpen, setIsCMFileFilterPanelOpen] = React.useState(false);
  const [isCMFileSharePanelOpen, setIsCMFileSharePanelOpen] = React.useState(false);
  const [isCMMoveFilesListPanelOpen, setIsCMMoveFilesListPanelOpen] = React.useState(false);
  const [selectedNewDocumentTemplate, setSelectedNewDocumentTemplate] = React.useState<NewDocumentTemplate>();
  const [quickFilterValue, setQuickFilterValue] = React.useState<string>("");
  const [showConfirmMoveToDialog, setShowConfirmMoveToDialog] = React.useState<boolean>(false);
  const [isBusyCreatingMoveToJobQue, setIsBusyCreatingMoveToJobQue] = React.useState<boolean>(false);
  const [htmlConfirmMessage, setHtmlConfirmMessage] = React.useState<JSX.Element>();
  const [isMarqueeEnabled, setIsMarqueeEnabled] = React.useState(true);
  const [externalResourceUrl, setExternalResourceUrl] = React.useState<IExternalResourceUrl>();
  const [showLoadingSpinner, setShowLoadingSpinner] = React.useState<boolean>(false);
  const [isLoadingNextPage, setIsLoadingNextPage] = React.useState<boolean>(false);

  const [renderListAsStreamByID] = useLazyRenderListAsStreamByIDQuery();
  const [getItemWebUrl] = useLazyGetItemWebUrlQuery();

  const itemUpdatedId = React.useRef<string | undefined>();
  const mousePosition = React.useRef<Point>();
  const detailsListRef = React.useRef<IDetailsList>();
  const focusZoneRef = React.useRef<HTMLElement>();
  const isInOneDrive = React.useRef(false);
  const _selection = React.useRef(new Selection({
    onSelectionChanged: () => getSelectionDetails()
  }));
  const masterIdsRemoved = React.useRef<string[]>([]);

  const getSelectionDetails = () => {
    const filteredSelectedItems = _selection.current.getSelection().filter(x => x && x[rowLockIndicator] !== true);

    setSelectedItems({ items: filteredSelectedItems, count: filteredSelectedItems ? filteredSelectedItems.length : 0 });

    if (filteredSelectedItems?.length === 1) {
      let selectedItem: any = filteredSelectedItems[0];
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(selectedItem.ProgId === OneNoteProgId ? OneNoteProgId : selectedItem[".fileType"]));
      setSelectedItem(selectedItem);
    } else {
      setSelectedItemInfo(null);
      setSelectedItem(null);
    }
  }

  const fileInputRef = React.useRef<HTMLInputElement>();
  const folderInputRef = React.useRef<HTMLInputElement>();

  React.useEffect(() => {
    const handleDocumentBodyKeyDown = (event: any) => {
      if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
        return;
      }

      if (event.key === "Delete" || event.keyCode === 46) {
        if (_selection.current.getSelection().length > 0) {
          setShowDeleteDialog(true);
        }
      }
      // Check if Ctrl (or Command on Mac) and "a" are pressed
      else if ((event.ctrlKey || event.metaKey) && event.key === "a") {
        event.preventDefault();
        _selection.current.setAllSelected(true);
      }
      else if (event.key === "Escape" && event.target === event.currentTarget) {
        _selection.current.setAllSelected(false);
      }
    };

    document.body.addEventListener("keydown", handleDocumentBodyKeyDown);

    if (focusZoneRef.current) {
      focusZoneRef.current.addEventListener("mouseenter", handleMouseEnter);
      focusZoneRef.current.addEventListener("mouseleave", handleMouseLeave);
    }

    return () => {
      document.body.removeEventListener("keydown", handleDocumentBodyKeyDown);

      if (focusZoneRef.current) {
        focusZoneRef.current.removeEventListener("mouseenter", handleMouseEnter);
        focusZoneRef.current.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);

  const sharePanelModeRef = React.useRef<SharePanelMode>(SharePanelMode.Share);
  const openSharePanel = React.useCallback((mode: SharePanelMode) => {
    sharePanelModeRef.current = mode;
    setIsCMFileSharePanelOpen(true);
  }, []);

  const pickFiles = React.useCallback(() => {
    fileInputRef.current?.click();
  }, [fileInputRef.current]);

  const pickFolder = React.useCallback(() => {
    folderInputRef.current?.click();
  }, [folderInputRef.current]);

  const handleSelectedFiles = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const filesToUpload: IFileToUpload[] = DragAndDropHelper.handleSelectedFiles(event);
    if (filesToUpload?.length > 0) {
      dispatch(addUploadedFiles(filesToUpload));
      setIsCMUploadFilesPanelOpen(true);
    }
    (event.target as HTMLInputElement).value = null;
  }, []);

  const handleMouseEnter = React.useCallback((ev: any) => {
    setIsMarqueeEnabled(false);
  }, []);

  const handleMouseLeave = React.useCallback((ev: any) => {
    setIsMarqueeEnabled(true);
  }, []);

  const clearItemSelection = React.useCallback(() => {
    _selection.current.setAllSelected(false);
    setSelectedItem(null);
    setSelectedItems({ items: [], count: 0 });
    setSelectedItemInfo(null);
  }, []);

  const triggerContextMenu = (ev: any, position?: Point) => {
    mousePosition.current = position ? position : { left: ev.clientX, top: ev.clientY };
    setOpenContextMenu(true);
  }

  const setGridItemIsBusy = (items: any[], isBusy: boolean) => {
    const newGridProps = { ...gridProps };
    let newRows = [];
    newGridProps.items.forEach(gridItem => {
      let foundItem = false;
      items.forEach(item => {
        if (!foundItem && gridItem && gridItem.ID === item.ID) {
          newRows.push({ ...item, isBusy });
          foundItem = true;
        }
      });
      if (!foundItem) {
        newRows.push(gridItem);
      }
    });

    newGridProps.items = [...newRows];

    setGridProps(newGridProps);
  }

  const updateGridItems = async (items: any[]) => {
    let serverRelativePath = '';
    if (currentDirectory?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.serverRelativePath) {
      serverRelativePath = currentDirectory?.serverRelativePath;
    }
    else if (currentDirectory?.directory?.length > 0 && currentDirectory?.parentId) {
      let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
      const results = await getItemWebUrl({ driveId, itemId: currentDirectory?.id, accessToken: await authModule.getGraphAccessToken() }).unwrap();
      serverRelativePath = tryDecodeUriComponent(new URL(results.listItem?.webUrl || results.webUrl).pathname);
    }

    const updatedItems: any[] = await Promise.all(items.map(async item => {
      return renderListAsStreamByID({
        siteUrl: isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl,
        sharePointListId: currentDirectory?.sharePointListId,
        viewId: selectedView?.Id,
        accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        Id: item.ID,
        serverRelativePath
      }).unwrap();
    }));

    const newGridProps = { ...gridProps };

    const newRows = [];
    newGridProps.items.forEach(item => {
      let foundItem = false;
      updatedItems.forEach(updatedItem => {
        if (!foundItem && item && item.ID === updatedItem.ListData.Row[0].ID) {
          newRows.push({ ...updatedItem.ListData.Row[0], isBusy: false });
          setSelectedItem({ ...updatedItem.ListData.Row[0], isBusy: false });
          foundItem = true
        }
      });

      if (!foundItem) {
        newRows.push(item);
      }
    });

    newGridProps.items = [...newRows];
    setGridProps({ ...newGridProps, items: [...newGridProps.items] });
    getSelectionDetails();
  }

  // const nintexDialogRef = React.useRef<any>();
  const [isReloadWatcherActive, setIsReloadWatcherActive] = React.useState<boolean>(false);
  const openCreateTemplateModal = (selectedTemplate: NewDocumentTemplate) => {
    setSelectedNewDocumentTemplate(selectedTemplate);

    if (selectedTemplate?.contentTypeId === "0x0120D520006AAF2894D132DC4490C0776F6D6D2CA40035E1CF0A0F777246BCE4531413CFCF86") {
      /**
       * adding winLeft and winTop to account for dual monitor
       * using screenLeft and screenTop for IE8 and earlier
       */
      const winLeft = window.screenLeft ? window.screenLeft : window.screenX;
      const winTop = window.screenTop ? window.screenTop : window.screenY;
      /**
       * window.innerWidth displays browser window"s height and width excluding toolbars
       * using document.documentElement.clientWidth for IE8 and earlier
       */
      const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
      const left = Math.max(0, ((width / 2) - (600 / 2)) + winLeft);
      const top = Math.max(0, ((height / 2) - (800 / 2)) + winTop);

      //const nintexFormUrl: URL = new URL("https://xblox-574017.workflowcloud.com/forms/be3952f0-9079-4612-b518-9d5cf947b8f6");
      const nintexFormUrl: URL = new URL("https://xblox-574017.workflowcloud.com/forms/17f995a0-fbab-4cef-b89b-0c0e0b2a8f0a");
      // nintexDialogRef.current = window.open(nintexFormUrl.href, "Docubird.Nintex", `width=615, height=800, top=${top}, left=${left}, scrollbars=yes`);

      const nintexWin = window.open(nintexFormUrl.href, "Docubird.Nintex", `width=615, height=800, top=${top}, left=${left}, scrollbars=yes`);

      // const reloadInterval: number = 25000;
      // const reloadLimit: number = 2;
      // const timer = setInterval(() => {
      //   if (nintexWin.closed) {
      //     clearInterval(timer);
      //     let x = 0;
      //     let timeOutId = setTimeout(function reload() {
      //       // dispatch(toggleReload());
      //       if (++x === reloadLimit) {
      //         clearTimeout(timeOutId);
      //       } else {
      //         timeOutId = setTimeout(reload, reloadInterval);
      //       }
      //     }, reloadInterval);
      //   }
      // }, 1000);
      const intervalId = setInterval(() => {
        if (nintexWin.closed) {
          clearInterval(intervalId);
          setIsReloadWatcherActive(true);
        }
      }, 1000);

    } else if (selectedTemplate?.templateId === "NewFolder" || selectedTemplate?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder)) {
      setIsCMCreateFolderPanelOpen(true);
    } else if (selectedTemplate?.templateId === "NewLink") {
      setIsCMCreateLinkPanelOpen(true);
    } else if (workingDirectories?.some(x => x.type === ComponentTypes.SharePointList)) {
      setIsCMUploadFilesPanelOpen(true);
    }
    else {
      setInfoPanelMode(InfoPanelMode.NewTemplate);
      setIsCMFileInfoPanelOpen(true);
    }
  }

  const openFilePreviewFromLink = (item: any) => {
    setSelectedItem({ ...item });
    setIsCMFilePreviewPanelOpen(true);
  }

  const openExternalResourceUrl = (externalResourceUrl: IExternalResourceUrl) => {
    setExternalResourceUrl(externalResourceUrl);
  }

  const openFileInfoPanel = React.useCallback((itemIndex: number) => {
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(itemIndex, true, true);
    setInfoPanelMode(InfoPanelMode.Update);
    setIsCMFileInfoPanelOpen(true);
  }, []);

  const [pdfConvertIsDuplicate, setPdfConvertIsDuplicate] = React.useState<boolean>(false);
  const [pdfConvertShowVersion, setPdfConvertShowVersion] = React.useState<boolean>(false);

  const openDuplicateFileVersionSelectorModal = (isDuplicate: boolean, showVersion: boolean) => {
    setPdfConvertIsDuplicate(isDuplicate);
    setPdfConvertShowVersion(showVersion);
    setShowDuplicateFileVersionSelectorModal(true);
  }

  const {
    isFetchingData,
    gridProps,
    viewsWithColumns,
    selectedView,
    scrollToTopToggle,
    isAllCollapsedRef,
    serverRelPath,
    folderPath,
    newDocumentTemplates,
    libraryMinVerEnabled,
    listTitle,
    listFields,
    listHttpRoot,
    setSelectedView,
    fetchGroupedDrillDownData,
    fetchGroupedDrillDownDataAllGroups,
    onSortColumn,
    reloadGrid,
    fetchListStreamNextPage,
    setGridProps,
    setIsFetchingData,
    getTimeZoneFormattedDate,
    onFolderClick
  } = useContentManagerBody(triggerContextMenu, openFilePreviewFromLink, openFileInfoPanel, openExternalResourceUrl, clearItemSelection);

  const { menuItem_QuickFilter, resetQuickFilterValue } = useMenuItem_QuickFilter(setQuickFilterValue);

  const { contextMenu, commandBarMenu, deleteSuccess } = useMenuItems(
    mode,
    selectedItems.items,
    waitFor,
    setWaitFor,
    waitForContext,
    setWaitForContext,
    isInOneDrive.current,
    listFields,
    selectedItemInfo,
    setIsCMCreateFolderPanelOpen,
    setIsCMUploadFilesPanelOpen,
    setShowRenameDialog,
    setIsCMFileInfoPanelOpen,
    setInfoPanelMode,
    setApprovalFiles,
    setIsApprovalsPanelOpen,
    setShowDeleteDialog,
    setShowVersionHistoryDialog,
    setIsPublish,
    setShowCheckinDialog,
    gridProps,
    setGridProps,
    setSelectedItems,
    setIsCMFilePreviewPanelOpen,
    setSelectionCleared,
    setGridItemIsBusy,
    updateGridItems,
    viewsWithColumns,
    selectedView,
    setSelectedView,
    setIsCMErrorModalOpen,
    setErrorMessage,
    setIsCMVersionAppRejModalOpen,
    setIsCMFileFilterPanelOpen,
    newDocumentTemplates,
    openCreateTemplateModal,
    quickFilterValue,
    gridProps?.items?.length > 0 && selectedItems.count === 0 && menuItem_QuickFilter,
    setIsCMMoveFilesListPanelOpen,
    setShowConfirmMoveToDialog,
    isFetchingData,
    openSharePanel,
    setShowCancelAssignmentDialog,
    libraryMinVerEnabled,
    openDuplicateFileVersionSelectorModal,
    reloadGrid,
    pickFiles,
    pickFolder,
    setIsSigningPanelOpen,
    setIsFileUploadProgressPanelOpen
  );

  React.useEffect(() => {
    if (moveTo.busyMovingFiles
      && moveTo.sourceDirectory?.id
      && currentDirectory?.id
      && moveTo.sourceDirectory.id === currentDirectory.id
      && moveTo.copyJobResultsCompletedIds?.length > 0) {

      let filteredList = moveTo.copyJobResultsCompletedIds?.filter(id => !masterIdsRemoved.current.includes(id));
      if (filteredList?.length > 0) {
        masterIdsRemoved.current.push(...moveTo.copyJobResultsCompletedIds);
        if (gridProps?.items?.length > 0) {
          const newRows: any[] = [];

          gridProps.items.forEach((item) => {
            //check for virtual scrolling null item
            if (item) {
              const shouldRemoveItemFromGrid = filteredList.includes(item.UniqueId?.toLowerCase().replace("{", "").replace("}", ""));
              if (!shouldRemoveItemFromGrid) {
                newRows.push(item);
              }
            }
          });

          setGridProps({ ...gridProps, items: [...newRows] });
        }
      }
    }
  }, [moveTo.busyMovingFiles, moveTo.copyJobResultsCompletedIds, moveTo.sourceDirectory, currentDirectory, gridProps]);

  React.useEffect(() => {
    if (currentDirectory) {
      isInOneDrive.current = currentDirectory.type == ComponentTypes.OneDrive || currentDirectory.type == ComponentTypes.OneDriveSubFolder;
      DragAndDropHelper.destinationDirectory = currentDirectory;
      if (generalModule.getOpenPanelUploadPanel()) {
        generalModule.setOpenPanelUploadPanel(false);
        setIsCMUploadFilesPanelOpen(true);
      }
    }
  }, [currentDirectory]);

  const reloadTimoutId = React.useRef<NodeJS.Timeout>();
  const stopReloadWatcher = () => {
    if (reloadTimoutId.current) {
      clearTimeout(reloadTimoutId.current);
      reloadTimoutId.current = null;
    }
    setIsReloadWatcherActive(false);
  }

  React.useEffect(() => {
    const reloadInterval: number = 10000;
    const reloadLimit: number = 3;
    if (isReloadWatcherActive) {
      let x = 0;
      reloadTimoutId.current = setTimeout(function reload() {
        reloadGrid();
        if (++x === reloadLimit) {
          clearTimeout(reloadTimoutId.current);
          stopReloadWatcher();
        } else {
          reloadTimoutId.current = setTimeout(reload, reloadInterval);
        }
      }, reloadInterval);
    }
    else if (reloadTimoutId?.current) {
      stopReloadWatcher();
    }

    return () => {
      if (reloadTimoutId?.current) {
        stopReloadWatcher();
      }
    }
  }, [currentDirectory, isReloadWatcherActive]);

  // React.useEffect(() => {
  //   if (!isFetchingData && selectedItems.items?.length === 0 && moveToEnabled && currentDirectory.id === moveToDirectory?.id && (moveToMode === ContentManagerCopyMoveModeEnum.Copy || moveToMode === ContentManagerCopyMoveModeEnum.Move)) {
  //     //browsing back to move/copy source directory - reselecting items
  //     const moveToSelectedItems: any[] = [];

  //     gridProps?.items?.forEach((item, index) => {
  //       const fileSelected = moveTo.selectedFiles.find(x => x.UniqueId === item?.UniqueId);
  //       if (fileSelected) {
  //         _selection.current.setIndexSelected(index, true, false);
  //         moveToSelectedItems.push({ ...fileSelected });
  //       }
  //     });

  //     getSelectionDetails();
  //   }
  // }, [selectedItems?.items, isFetchingData, moveToEnabled, currentDirectory, moveToDirectory]);

  React.useEffect(() => {
    if (!isBusySaving) {
      reloadGrid();
    }
  }, [isBusySaving]);

  React.useEffect(() => {
    DragAndDropHelper.canCreateFolder = currentSharepointFolder.canCreateFolder;
  }, [currentSharepointFolder.canCreateFolder]);

  React.useEffect(() => {
    if (moveToIsMoveComplete) {
      masterIdsRemoved.current = [];
    }
    if (moveToIsMoveComplete && moveTo.destinationDirectory?.id === currentDirectory?.id) {
      reloadGrid();
    }
  }, [moveToIsMoveComplete, moveTo.destinationDirectory, currentDirectory]);

  React.useEffect(() => {
    if (moveToIsMoveComplete && moveTo.sourceDirectory?.id === currentDirectory?.id) {
      setSelectionCleared(true);
    }
  }, [moveToIsMoveComplete, moveTo.sourceDirectory, currentDirectory]);

  React.useEffect(() => {
    if (openContextMenu) {
      const menuProps: IContextualMenuProps = {
        target: mousePosition.current,
        directionalHint: DirectionalHint.rightTopEdge,
        directionalHintFixed: true,
        items: contextMenu,
        onDismiss: () => {
          setOpenContextMenu(false);
          setContextualMenuProps(undefined);
        },
      };
      setContextualMenuProps(menuProps);
    }
  }, [openContextMenu, contextMenu]);

  React.useEffect(() => {
    detailsListRef?.current?.scrollToIndex(0);
  }, [scrollToTopToggle]);

  React.useEffect(() => {
    if (selectionCleared) {
      clearItemSelection();
      setSelectionCleared(false);
    }
  }, [selectionCleared]);

  React.useEffect(() => {
    if (exchangeProgress && exchangeProgress.status === BackgroundTaskStatusEnum.Completed && !isCMMoveFilesListPanelOpen) {
      dispatch(setContentManagerExchangeProgress(undefined));
    }
    else if (!moveTo.busyFetchingFiles && !moveTo.busyMovingFiles && !isCMMoveFilesListPanelOpen) {
      dispatch(setContentManagerMoveTo({ isMoveInProgress: false }));
    }
  }, [exchangeProgress, isCMMoveFilesListPanelOpen, moveTo.busyFetchingFiles, !moveTo.busyMovingFiles]);

  React.useEffect(() => {
    let loaderTimer: NodeJS.Timeout;
    if (isFetchingData && !(gridProps?.columns?.length > 0)) {
      loaderTimer = setTimeout(() => {
        setShowLoadingSpinner(true);
      }, 500);
    }
    else {
      setShowLoadingSpinner(false);
    }

    return () => {
      clearTimeout(loaderTimer);
    };
  }, [isFetchingData, gridProps?.columns]);

  React.useEffect(() => {
    if (selectedView?.viewType === ViewTypes.TILES) {
      _selection.current.setItems(gridProps?.items ?? [], false);
    }
  }, [selectedView, gridProps?.items]);

  const renderNoResultsFound = React.useCallback((): JSX.Element => {
    return (
      <Stack verticalAlign="center" horizontalAlign="center" styles={noResultsStackStyles}>
        <StackItem align="center">
          <img src={searchIconSrc} />
        </StackItem>
        <StackItem align="center">
          <Label disabled>{languageStrings.NoResultsFound}</Label>
        </StackItem>
      </Stack>
    );
  }, []);

  const onColumnHeaderClicked = (ev?: React.MouseEvent<HTMLElement, MouseEvent>, column?: IGridColumn) => {
    onSortColumn(column, quickFilterValue ? true : false);
  }

  const onRenderHeader = (headerProps: IGroupDividerProps, defaultRender: IRenderFunction<IGroupHeaderProps>) => {
    return (
      <span>
        {defaultRender(
          {
            ...headerProps,
            styles: { headerCount: headerCountStyle }
          })}
      </span>
    );
  }

  const onGroupToggle = (group: IGroup) => {
    if (!group.children && group.count === 0) {
      fetchGroupedDrillDownData(group);
    }
  }

  const _onRenderDetailsFooter = (detailsFooterProps: IDetailsFooterProps): JSX.Element => {
    return !isFetchingData && gridProps?.items.length === 0 && gridProps?.groups.length === 0
      ? renderNoResultsFound()
      : <></>;
  }

  const _onRenderRow: IDetailsListProps['onRenderRow'] = rowProps => {
    // const privacySensitive = rowProps.item[piiConfig.privacySentitiveColumnName];
    // const privacySensitiveData = rowProps.item[piiConfig.privacySentitiveDataColumnName];

    // let rowStyles: Partial<IDetailsRowStyles> = {
    //   cell: {
    //     display: "inline-flex",
    //     alignItems: "center"
    //   },
    //   checkCell: {
    //     height: "100%"
    //   }
    // };

    // if (tenantEnablePII && privacySensitive !== undefined) {
    //   if (privacySensitive === 'True' || privacySensitive === 'Yes') {
    //     rowStyles = { ...detailRowPiiDetectedStylesCM }
    //   }
    //   else if (privacySensitiveData === "-") {
    //     rowStyles = { ...detailRowPiiNotDetectedStylesCM }
    //   }
    // }
    return (
      <DraggableContainer
        isValidDropZone={rowProps.item.FSObjType === "1"}
        onDropBeforeFiles={() => setIsFetchingData(true)}
        onDropAfterFiles={(selectedGridItems?: any[]) => onGridItemDrop(rowProps.item, true, selectedGridItems)}
        onDragHover={() => onGridItemDrop(rowProps.item, false)}
        gridItem={rowProps.item}
      >
        <DetailsRow
          {...rowProps}
          styles={rowStyles}
          disabled={rowProps.item[rowLockIndicator] === true}
          className={detailsListClassNames.row}
        />
      </DraggableContainer>
    )
  }

  const _onRenderDetailsHeader: IDetailsListProps['onRenderDetailsHeader'] = props => {
    if (props) {
      const listRef = detailsListRef?.current as any;
      return <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
        <DetailsHeader {...props} isAllCollapsed={!listRef?.props?.groups?.some(x => !x.isCollapsed)} />
      </Sticky>;
    }
    return null;
  }

  const onRenderCustomPlaceholder = (rowProps: IDetailsRowProps, index?: number, defaultRender?: (props: IDetailsRowProps) => React.ReactNode) => {
    if (rowProps.item === null) {
      fetchListStreamNextPage();
    }
    return defaultRender(rowProps);
  }

  const onToggleCollapseAll = async (isAllCollapsed: boolean) => {
    if (!isAllCollapsed) {
      const groupingCount = gridProps.groupProps.names.length;
      if (groupingCount === 1) {
        await fetchGroupedDrillDownDataAllGroups();
      }
    }

    isAllCollapsedRef.current = isAllCollapsed;
  }

  const metaDataUpdated = async (item: any, inputValuesToSave: SharePointInputData[], selectedContentTypeId: string, extention?: string, replacementFile?: IFileToUpload, closeFileInfoPanel: boolean = true) => {
    itemUpdatedId.current = undefined;
    try {
      if (infoPanelMode === InfoPanelMode.NewTemplate) {
        reloadGrid();
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        setSelectedNewDocumentTemplate(null);
        return;
      }

      if (infoPanelMode === InfoPanelMode.Replace && replacementFile && replacementFile.extension !== extention) {
        reloadGrid();
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        return;
      }

      let serverRelativePath = '';
      if (currentDirectory?.contentTypeId?.startsWith(SharePointFolderContentTypeIds.folder) && currentDirectory.serverRelativePath) {
        serverRelativePath = currentDirectory?.serverRelativePath;
      }
      else if (currentDirectory?.directory?.length > 0 && currentDirectory?.parentId) {
        let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
        const results = await getItemWebUrl({ driveId, itemId: currentDirectory?.id, accessToken: await authModule.getGraphAccessToken() }).unwrap();
        serverRelativePath = tryDecodeUriComponent(new URL(results.listItem?.webUrl || results.webUrl).pathname);
      }

      if (closeFileInfoPanel) {
        setInfoPanelMode(null);
        setIsCMFileInfoPanelOpen(false);
        setSelectedNewDocumentTemplate(null);
      }

      setShowRenameDialog(false);
      let listStreamByID = await renderListAsStreamByID({
        siteUrl: isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl,
        sharePointListId: currentDirectory?.sharePointListId,
        viewId: selectedView?.Id,
        accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
        Id: selectedItem.ID,
        serverRelativePath
      }).unwrap();

      if (listStreamByID.ListData?.Row?.length > 0) {
        const newGridProps = { ...gridProps };

        const newRows = [];
        newGridProps.items.forEach(item => {
          if (item && item.ID === listStreamByID.ListData.Row[0].ID) {
            newRows.push(listStreamByID.ListData.Row[0]);
            setSelectedItem({ ...listStreamByID.ListData.Row[0] });
          } else {
            newRows.push(item);
          }
        });

        setSelectedItems({ items: [listStreamByID.ListData.Row[0]], count: 1 });

        newGridProps.items = [...newRows];
        setGridProps(newGridProps);
      }
      else {
        if (!closeFileInfoPanel) {
          const newRows = [];
          gridProps.items.forEach((item, index) => {
            if (item && item.ID === selectedItem.ID) {
              newRows.push({ ...item, [rowLockIndicator]: true });
            } else {
              newRows.push(item);
            }
          });
          setGridProps({ ...gridProps, items: newRows });
        }
        else {
          reloadGrid();
        }
      }
    } catch (error) {
      logger(error, "ContentBodyFilesFolders.tsx (metaDataUpdated)");
    }
  }

  const onFolderCreated = () => {
    setIsCMCreateFolderPanelOpen(false);
    setSelectedNewDocumentTemplate(null);
    reloadGrid();
  }

  const onDeleteCloseSuccess = (successIds: string[], hasError: boolean) => {
    deleteSuccess(successIds)

    if (hasError) {
      setIsCMErrorModalOpen(true);
      setErrorMessage(languageStrings.ErrorDeletingFiles);
    }
  }

  const onCancelAssignmentSuccess = (hasError: boolean) => {
    setShowCancelAssignmentDialog(false)

    if (hasError) {
      setIsCMErrorModalOpen(true);
      setErrorMessage(languageStrings.ErrorDeletingFiles);
    } else {
      reloadGrid();
      setTimeout(() => {
        dispatch(setLastApprovalLoad());
      }, 3000);
    }
  }

  const quickFilterPredicate = React.useCallback((result: any) => {
    if (result === undefined || result === null) {
      // Limit continuous auto paging to a max of 300 items
      return gridProps?.items?.length > 1 && gridProps.items.length < 300;
    }
    else {
      const resultProperties = Object.keys(result);
      return resultProperties.some(property => {
        return quickFilterPropValPredicate(result, property);
      });
    }
  }, [gridProps, filterFields, quickFilterValue]);

  const quickFilterPropValPredicate = React.useCallback((result: any, property: any) => {
    try {
      const propertyField: any = filterFields?.find(field => field.RealFieldName?.toLowerCase() === property.toLowerCase());
      const propertyType: string = propertyField?.FieldType ?? propertyField?.Type;
      let propertyValue: string;
      if (propertyType) {
        switch (propertyType) {
          case "DateTime":
          case "DateOnly":
            propertyValue = result[property] ? dayjs(result[property]).utc().local().format("L LT")?.toLowerCase() : null;
            break;

          case "User":
          case "UserMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.title?.toLowerCase())?.join(";") : null;
            break;

          case "TaxonomyFieldType":
            propertyValue = result[property]?.Label?.toLowerCase();
            break;

          case "TaxonomyFieldTypeMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.Label?.toLowerCase())?.join(";") : null;
            break;

          case "MultiChoice":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.toString()?.toLowerCase())?.join(";") : null;
            break;

          case "LookupMulti":
            propertyValue = Array.isArray(result[property]) ? result[property].map(item => item?.lookupValue?.toLowerCase())?.join(";") : null;
            break;

          default:
            propertyValue = result[property]?.toString().toLowerCase();
            break;
        }
      }
      return propertyValue?.includes(quickFilterValue.toLowerCase());
    } catch (error) {
      // Do not log to generic logger as it may flood the db.
      console.error(error);
    }
    return true;
  }, [filterFields, quickFilterValue]);

  const onConfirmMoveFiles = async (isSaving: boolean) => {
    if (!isSaving) {
      let progressCountTotal = moveTo.selectedFiles ? moveTo.selectedFiles.length : 0;
      if (moveToMode === ContentManagerCopyMoveModeEnum.CopyAll || moveToMode === ContentManagerCopyMoveModeEnum.MoveAll) {
        if (folderPath?.length === 0) {
          const settings = await getListSettings(isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(), moveTo.sourceSiteUrl, currentDirectory.sharePointListId);
          progressCountTotal = settings.ItemCount;
        } else {
          progressCountTotal = gridProps?.items?.length
        }
      }

      dispatch(setContentManagerMoveTo({
        moveToEnabled: true,
        sourceServerRelPath: serverRelPath,
        progressCountTotal
      }));
      setShowConfirmMoveToDialog(false);
    }
    else if (moveToMode === ContentManagerCopyMoveModeEnum.CopyAll || moveToMode === ContentManagerCopyMoveModeEnum.MoveAll) {
      const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;

      dispatch(setContentManagerMoveTo({
        siteUrl,
        isMoveInProgress: true,
        busyFetchingFiles: true,
        destinationServerRelPath: serverRelPath,
        destinationDirectory: currentDirectory
      }));
      setShowConfirmMoveToDialog(false);
      dispatch(setContentManagerMoveToSelectedFilesIsBusyProgress([], true));
      setIsCMMoveFilesListPanelOpen(true);
    }
    else {
      try {
        const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;

        setIsBusyCreatingMoveToJobQue(true); //Confirm move to modal spinner
        const copyRequest = {
          siteUrl,
          accessToken: isInOneDrive?.current ? await authModule.getOneDriveAccessToken() : await authModule.getSharePointAccessToken(),
          files: moveTo.selectedFiles,
          sourceSiteUrl: moveTo.sourceSiteUrl,
          sourceServerRelPath: moveTo.sourceServerRelPath,
          destinationServerRelPath: serverRelPath,
          isMoveMode: (moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? true : false
        }

        let copyJobResults = await createCopyJobs(copyRequest);
        if (copyJobResults?.success) {
          dispatch(setContentManagerMoveToSelectedFilesIsBusyProgress([], true));
          dispatch(setContentManagerMoveTo({
            siteUrl,
            busyMovingFiles: true,
            isMoveInProgress: true,
            moveToEnabled: false,
            destinationDirectory: currentDirectory
          }));
          dispatch(setContentManagerMoveToCopyJobResults(copyJobResults?.jobs))

          setIsCMMoveFilesListPanelOpen(true);
        }
        else {
          dispatch(resetContentManagerMoveTo());
          dispatch(setContentManagerMoveToError(copyJobResults.error));
        }

        setIsBusyCreatingMoveToJobQue(false);
        setShowConfirmMoveToDialog(false);

      } catch (error) {
        setIsBusyCreatingMoveToJobQue(false);
        setShowConfirmMoveToDialog(false);
        setIsCMErrorModalOpen(true);
        setErrorMessage(error.data["odata.error"]["message"]["value"]);

        logger(error, "ContentBodyFilesFolders.tsx (onConfirmMoveFiles (else))");
      }
    }
  }

  React.useEffect(() => {
    if (showConfirmMoveToDialog) {
      let confirmMessage = (moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll)
        ? languageStrings.SelectDestinationDirectoryConfirmMove
        : languageStrings.SelectDestinationDirectoryConfirmCopy

      const partsAmountSplit = confirmMessage.split("{amount}");
      const partsSourceSplit = partsAmountSplit[1].split("{source}");

      let amountStr = (moveTo.mode === ContentManagerCopyMoveModeEnum.CopyAll || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll)
        ? languageStrings.All.toLowerCase()
        : moveTo.selectedFiles?.length?.toString();

      setHtmlConfirmMessage(<div style={{ wordWrap: "break-word" }}>{partsAmountSplit[0]}<b>{amountStr}</b>{partsSourceSplit[0]}<b>{moveToSourceServerRelPath}</b>{partsSourceSplit[1]}</div>);
    }
  }, [showConfirmMoveToDialog, moveToSourceServerRelPath]);

  const onGridDrop = React.useCallback(async () => {
    if (DragAndDropHelper.mode === DragMode.gridItems && DragAndDropHelper.selectedGridItems?.length > 0) {
      let serverRelativePath: string = serverRelPath ? serverRelPath : currentDirectory?.serverRelativePath;
      if (!serverRelativePath && currentDirectory?.directory?.length > 0 && currentDirectory?.id) {
        const driveId = isInOneDrive.current && oneDriveRootDetails ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);
        const webUrl = await getListItemWebUrl(await authModule.getGraphAccessToken(), driveId, currentDirectory.parentId ? currentDirectory.id : null);
        if (webUrl) {
          serverRelativePath = tryDecodeUriComponent(new URL(webUrl).pathname);
        }
      }
      const siteUrl = isInOneDrive.current && oneDriveRootDetails ? oneDriveRootDetails.sharePointSiteUrl : currentDirectory?.webUrl;
      DragAndDropHelper.handleGridMove(dispatch, siteUrl, workingDirectories, isInOneDrive.current, serverRelativePath);
    } else if (DragAndDropHelper.mode === DragMode.files) {
      setIsCMUploadFilesPanelOpen(true);
    }
  }, [oneDriveRootDetails, currentDirectory, workingDirectories, serverRelPath]);

  const onGridItemDrop = React.useCallback(async (item, hasDropContent: boolean = true, selectedGridItems?: any[]) => {
    try {
      let itemid = "";
      let driveId = isInOneDrive.current ? oneDriveRootDetails.driveId : (currentDirectory.parentId ? currentDirectory.parentId : currentDirectory.id);

      const spItemUrlparts = item['.spItemUrl']?.split('/');
      if (spItemUrlparts) {
        itemid = spItemUrlparts[spItemUrlparts.length - 1].split('?')[0];
      }

      const siteUrlPath: string = new URL(currentDirectory.webUrl)?.pathname + "/";

      const itemToAdd: IPageSettings = {
        id: itemid,
        parentId: driveId,
        type: isInOneDrive.current ? ComponentTypes.OneDrive : ComponentTypes.SharePointFolders,
        siteId: currentDirectory.siteId,
        siteDisplayName: currentDirectory.siteDisplayName,
        webUrl: currentDirectory.webUrl,
        fileTitle: item.FileLeafRef,
        directory: item.FileRef.replace(siteUrlPath, ""),
        DocumentLibrary: currentDirectory.DocumentLibrary,
        displayName: item.FileLeafRef,
        isTeamsFolder: currentDirectory.isTeamsFolder,
        sharePointListId: currentDirectory.sharePointListId,
        contentTypeId: item.ContentTypeId,
        serverRelativePath: item.FileRef,
        sharePointUniqueId: item.UniqueId?.replace("{", "").replace("}", "")
      };

      if (DragAndDropHelper.mode === DragMode.files || !hasDropContent) {
        dispatch(addWorkingDirectory(itemToAdd));
        dispatch(setContentManagerSearchValue(""));
        dispatch(toggleContentManagerReload());
        setIsFetchingData(false);
      }

      if (hasDropContent) {
        if (DragAndDropHelper.mode === DragMode.gridItems && selectedGridItems?.length > 0) {
          const siteUrl = isInOneDrive?.current ? oneDriveRootDetails?.sharePointSiteUrl : currentDirectory?.webUrl;
          DragAndDropHelper.destinationDirectory = itemToAdd;
          DragAndDropHelper.handleGridMove(dispatch, siteUrl, workingDirectories, isInOneDrive?.current);
        }
        else if (DragAndDropHelper.mode === DragMode.files) {
          setIsCMUploadFilesPanelOpen(true);
        }
      }
    } catch (error) {
      logger(error, "ContentBodyFilesFolders.tsx (onGridItemDrop)");
    }
  }, [oneDriveRootDetails, currentDirectory, workingDirectories]);

  const dragEvents = React.useCallback(() => {
    return {
      canDrop: (dropContext?: IDragDropContext, dragContext?: IDragDropContext) => {
        return true;
      },
      canDrag: (item?: any) => {
        return !moveTo.busyMovingFiles;
      },
      onDragStart: (item?: any, itemIndex?: number, selectedItems?: any[], event?: DragEvent) => {
        let selectedGridItems: any[] = selectedItems?.filter(selectedItem => selectedItem);
        if (!Array.isArray(selectedGridItems)) {
          selectedGridItems = [];
        }

        if (gridProps?.items?.length > 0
          && item
          && (selectedGridItems.length === 0 || selectedGridItems.findIndex(selectedItem => selectedItem.ID === item.ID) === -1)) {
          const draggedItemIndex: number = gridProps.items.findIndex(x => x.ID === item.ID);
          if (draggedItemIndex > -1) {
            selectedGridItems.push(item);
            _selection.current.setAllSelected(false);
            _selection.current.setIndexSelected(draggedItemIndex, true, true);
          }
        }

        if (selectedGridItems?.length > 0) {
          event.dataTransfer.setData(DragAndDropHelper.gridDataTransferType, JSON.stringify(selectedGridItems));

          DragAndDropHelper.mode = DragMode.gridItems;
          DragAndDropHelper.sourceDirectory = currentDirectory;
          DragAndDropHelper.destinationDirectory = currentDirectory;
          DragAndDropHelper.sourceServerRelPath = serverRelPath;
          DragAndDropHelper.selectedGridItems = selectedGridItems.filter(selectedItem => selectedItem);
        }
      }
    }
  }, [currentDirectory, moveTo.busyMovingFiles, serverRelPath, gridProps?.items]);

  const getSelectedIndex = React.useCallback(() => {
    const selectedIndices: number[] = _selection.current?.getSelectedIndices();
    if (Array.isArray(selectedIndices) && selectedIndices.length > 0 && gridProps?.items?.length > 0) {
      return selectedIndices[0];
    }
    return -1;
  }, [gridProps?.items]);

  const getIsMoveBackDisabled = React.useCallback(() => {
    let isMoveBackDisabled: boolean = true;
    const selectedIndex: number = getSelectedIndex();
    if (selectedIndex >= 1) {
      const prevItem = gridProps.items[selectedIndex - 1];
      if (prevItem && prevItem[rowLockIndicator] !== true) {
        isMoveBackDisabled = false;
      }
    }
    return isMoveBackDisabled;
  }, [gridProps?.items]);

  const getIsMoveForwardDisabled = React.useCallback(() => {
    let isMoveForwardDisabled: boolean = true;
    const selectedIndex: number = getSelectedIndex();
    if (selectedIndex !== -1 && selectedIndex < gridProps.items.length) {
      const nextItem = gridProps.items[selectedIndex + 1];
      if (nextItem && nextItem[rowLockIndicator] !== true) {
        isMoveForwardDisabled = false;
      }
    }
    return isMoveForwardDisabled;
  }, [gridProps?.items]);

  const move = React.useCallback((direction: MoveDirection) => {
    const currentSelectedIndex: number = getSelectedIndex();
    if (currentSelectedIndex !== -1) {
      let nextSelectedIndex: number;
      if (direction === MoveDirection.Back) {
        nextSelectedIndex = currentSelectedIndex - 1;
      }
      else {
        nextSelectedIndex = currentSelectedIndex + 1;
      }

      if ((gridProps.items.length - 1) >= nextSelectedIndex) {
        _selection.current.setAllSelected(false);
        _selection.current.setIndexSelected(nextSelectedIndex, true, true);
        detailsListRef.current?.focusIndex(nextSelectedIndex);
      }
    }
  }, [gridProps?.items]);

  const getIsPreviewNotSupported: boolean = React.useMemo(() => {
    try {
      return (!selectedItem?.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.document) || selectedItem?.ProgId === OneNoteProgId) === true;
    } catch (error) {
      // ignore
    }
    return false;
  }, [selectedItem]);

  const handleScroll = React.useCallback(async (event: React.UIEvent<HTMLElement>) => {
    if (gridProps?.hasMoreResults) {
      const el = event.target as HTMLDivElement;
      const bottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 300;
      if (bottom && !isLoadingNextPage) {
        setIsLoadingNextPage(true);
        await fetchListStreamNextPage();
        setIsLoadingNextPage(false);
      }
    }
  }, [isLoadingNextPage, gridProps?.hasMoreResults, fetchListStreamNextPage]);

  const onTileSelect = React.useCallback((item: any) => {
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), true, true);
    setSelectedItems({ items: [item], count: 1 });
    setSelectedItem({ ...item });
    setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(item.ProgId === OneNoteProgId ? OneNoteProgId : item[".fileType"]));
    setInfoPanelMode(InfoPanelMode.Update);
    setIsCMFileInfoPanelOpen(true);
  }, [gridProps?.items]);

  const onTileCheck = React.useCallback((item: any, checked: boolean) => {
    let updatedSelectedItems = selectedItems
      ? { items: [...(selectedItems.items ?? [])], count: (selectedItems.items?.length ?? 0) }
      : { items: [], count: 0 };

    if (checked) {
      updatedSelectedItems = { items: [...updatedSelectedItems.items, item], count: updatedSelectedItems.items.length + 1 };
    }
    else {
      updatedSelectedItems = { items: updatedSelectedItems.items.filter(selectedItem => selectedItem?.ID !== item?.ID), count: updatedSelectedItems.items.length > 0 ? updatedSelectedItems.items.length - 1 : 0 };
    }

    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), checked, checked);

    if (updatedSelectedItems.items.length === 1) {
      const newSelectedItem: any = updatedSelectedItems.items[0];
      setSelectedItem(newSelectedItem);
      setSelectedItemInfo(SearchOpenExtensionHelper.determineOfficeFileType(newSelectedItem.ProgId === OneNoteProgId ? OneNoteProgId : newSelectedItem[".fileType"]));
    }
    else {
      setSelectedItem(null);
      setSelectedItemInfo(null);
    }
    setSelectedItems(updatedSelectedItems);
  }, [selectedItems, gridProps?.items]);

  const onTileContextMenu = React.useCallback((ev: any, item: any) => {
    if (openContextMenu) {
      setOpenContextMenu(false);
      setContextualMenuProps(undefined);
    }
    _selection.current.setAllSelected(false);
    _selection.current.setIndexSelected(gridProps?.items?.findIndex(gridItem => gridItem?.ID === item.ID), true, true);
    setSelectedItems({ items: [item], count: 1 });
    setSelectedItem({ ...item });
    triggerContextMenu(ev);
  }, [gridProps?.items, openContextMenu]);

  const isDetailTile = React.useMemo(() => selectedView?.viewType === ViewTypes.TILES && selectedView?.tileDisplayFields?.length > 0, [selectedView]);

  const getViewItems = React.useCallback(() => {
    if (gridProps?.items?.length > 0) {
      return quickFilterValue
        ? gridProps.items.filter(quickFilterPredicate)
        : gridProps.items;
    }
    return [];
  }, [gridProps?.items, filterFields, quickFilterValue]);

  return (
    <>
      <input ref={fileInputRef} type="file" id="fileElem" multiple onChange={handleSelectedFiles} style={{ display: "none" }}></input>
      {/* @ts-expect-error */}
      <input ref={folderInputRef} type="file" id="folderElem" directory="" webkitdirectory="" multiple onChange={handleSelectedFiles} style={{ display: "none" }}></input>
      <ContentBodyCommandBar commandBarMenu={commandBarMenu} />
      {showLoadingSpinner
        ? <Stack verticalAlign="center" horizontalAlign="center" styles={loadingSpinnerStackStyles}><Spinner size={SpinnerSize.large} /></Stack>
        : <div className={detailsListClassNames.wrapper}>
          <DraggableContainer isValidDropZone={true} onDropAfterFiles={onGridDrop} isGrid={true}>
            {selectedView?.viewType === ViewTypes.TILES
              ? <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto} onScroll={handleScroll} styles={{ contentContainer: { paddingTop: 25, paddingBottom: 25, paddingLeft: 5, paddingRight: 5, overflowX: "hidden" } }}>
                {!isDetailTile && gridProps?.items?.some(x => x?.FSObjType === "1") && <Stack horizontal wrap tokens={{ childrenGap: 15 }} styles={{ root: { paddingBottom: 15 } }} >
                  {getViewItems()
                    .filter(x => x && x.FSObjType === "1")
                    .map((item, index) => {
                      return <ViewTile
                        key={`${item?.UniqueId}${index}`}
                        viewItem={item}
                        isSelected={item && selectedItems?.items?.findIndex(selectedItem => selectedItem?.ID === item.ID) !== -1}
                        isDetailTile={isDetailTile}
                        onTileSelect={onFolderClick}
                        onTileCheck={onTileCheck}
                        onTileContextMenu={onTileContextMenu}
                        getTimeZoneFormattedDate={getTimeZoneFormattedDate}
                      />
                    })}
                </Stack>}
                <Stack horizontal wrap tokens={{ childrenGap: 15 }} >
                  {(isDetailTile
                    ? getViewItems().filter(item => item)
                    : getViewItems().filter(x => x && x.FSObjType !== "1"))
                    .map((item, index) => {
                      return <ViewTile
                        key={`${item?.UniqueId}${index}`}
                        viewItem={item}
                        isSelected={item && selectedItems?.items?.findIndex(selectedItem => selectedItem?.ID === item.ID) !== -1}
                        isDetailTile={isDetailTile}
                        tileDisplayFields={selectedView?.tileDisplayFields}
                        listHttpRoot={listHttpRoot}
                        onTileSelect={item?.FSObjType === "1" ? onFolderClick : onTileSelect}
                        onTileCheck={onTileCheck}
                        onTileContextMenu={onTileContextMenu}
                        getTimeZoneFormattedDate={getTimeZoneFormattedDate}
                        openExternalResourceUrl={openExternalResourceUrl}
                      />
                    })}
                  {!isFetchingData && gridProps?.items.length === 0 && gridProps?.groups.length === 0 && renderNoResultsFound()}
                </Stack>
                {isLoadingNextPage && <Spinner size={SpinnerSize.large} styles={{ root: { padding: 25 } }} />}
              </ScrollablePane>
              : <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                <MarqueeSelection isEnabled={isMarqueeEnabled} selection={_selection.current}>
                  <ShimmeredDetailsList
                    componentRef={detailsListRef}
                    detailsListStyles={detailListStyles}
                    onRenderRow={_onRenderRow}
                    compact={false}
                    items={getViewItems()}
                    focusZoneProps={{
                      elementRef: focusZoneRef
                    }}
                    columns={gridProps?.columns?.length > 0 ? gridProps.columns : []}
                    onRenderDetailsHeader={_onRenderDetailsHeader}
                    selectionMode={!moveToEnabled ? SelectionMode.multiple : SelectionMode.none}
                    constrainMode={ConstrainMode.unconstrained}
                    onColumnHeaderClick={onColumnHeaderClicked}
                    setKey="multiple"
                    enableShimmer={isFetchingData}
                    dragDropEvents={dragEvents()}
                    layoutMode={DetailsListLayoutMode.justified}
                    isHeaderVisible={true}
                    selectionPreservedOnEmptyClick={true}
                    selection={_selection.current}
                    ariaLabelForSelectionColumn="Toggle selection"
                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                    checkButtonAriaLabel="Row checkbox"
                    onItemContextMenu={(item?: any, index?: number, ev?: MouseEvent) => {
                      if (!item[rowLockIndicator]) {
                        triggerContextMenu(ev);
                      }
                    }}
                    groupProps={{
                      showEmptyGroups: true,
                      onRenderHeader,
                      headerProps: {
                        onToggleCollapse: onGroupToggle
                      },
                      onToggleCollapseAll
                    }}
                    onRenderDetailsFooter={_onRenderDetailsFooter}
                    groups={!isFetchingData && gridProps?.groups?.length > 0 && !quickFilterValue ? gridProps?.groups : null}
                    onRenderCustomPlaceholder={onRenderCustomPlaceholder}
                  />
                </MarqueeSelection>
              </ScrollablePane>}
            {contextualMenuProps && <ContextualMenu {...contextualMenuProps} />}
          </DraggableContainer>
        </div>
      }
      {showVersionHistoryDialog && <CMVersionHistoryModal showDialog={showVersionHistoryDialog} closeDialog={() => setShowVersionHistoryDialog(false)} selectedItem={selectedItem} isInOneDrive={isInOneDrive.current} />}
      {showDuplicateFileVersionSelectorModal && <CMDuplicateFileVersionSelectorModal showDialog={showDuplicateFileVersionSelectorModal} closeDialog={() => { setShowDuplicateFileVersionSelectorModal(false); setWaitFor(false); }} closeOnSuccess={() => { setShowDuplicateFileVersionSelectorModal(false); reloadGrid(); setWaitFor(false); }} selectedItem={selectedItem} isDuplicate={pdfConvertIsDuplicate} showSelectVersion={pdfConvertShowVersion} />}
      {showCheckinDialog && <CMCheckinModal showDialog={showCheckinDialog} isPublish={isPublish} closeDialog={() => setShowCheckinDialog(false)} closeOnSuccess={() => { updateGridItems(selectedItems.items); setShowCheckinDialog(false) }} selectedItems={selectedItems.items} isInOneDrive={isInOneDrive.current} />}
      {isCMVersionAppRejModalOpen && <CMVersionAppRejModal showDialog={isCMVersionAppRejModalOpen} closeDialog={() => setIsCMVersionAppRejModalOpen(false)} closeOnSuccess={() => { updateGridItems(selectedItems.items); setIsCMVersionAppRejModalOpen(false) }} selectedItems={selectedItems.items} isInOneDrive={isInOneDrive.current} />}
      {isApprovalsPanelOpen && <WebPanel isOpen={isApprovalsPanelOpen} closePanel={() => setIsApprovalsPanelOpen(false)} headerText={languageStrings.AutomationFlowRequest} styles={{ main: { overflow: "unset" } }}>
        <AutomationPanel
          files={approvalFiles}
          isGraphQuery={true}
          tenantEnablePII={tenantEnablePII}
          closeClicked={() => setIsApprovalsPanelOpen(false)}
          tenantGuid={userAccount.tenantId}
          requestor={userAccount.username}
          isContentManager={true}
          listName={listTitle}
        />
      </WebPanel>}
      {isSigninPanelOpen && <WebPanel isOpen={isSigninPanelOpen} closePanel={() => setIsSigningPanelOpen(false)} headerText={languageStrings.SigningRequest} styles={{ main: { overflow: "unset" } }}>
        <SigningPanel
          files={approvalFiles}
          tenantEnablePII={tenantEnablePII}
          closeClicked={() => setIsSigningPanelOpen(false)}
          tenantGuid={userAccount.tenantId}
          requestor={userAccount.username}
          isContentManager={true}
          listName={listTitle}
        />
      </WebPanel>}
      {isCMFilePreviewPanelOpen && <WebPanel isOpen={isCMFilePreviewPanelOpen} width="1100px" closePanel={() => setIsCMFilePreviewPanelOpen(false)} headerText={selectedItem?.FileLeafRef} styles={previewWebPanelStyles}>
        {selectedItem && <CMFilePreviewPanel
          selectedItem={selectedItem}
          searchSource={SearchSource.Sharepoint}
          isInOneDrive={isInOneDrive.current}
          totalItemCount={gridProps?.items?.length}
          selectedItemIndex={getSelectedIndex()}
          previewNotSupported={getIsPreviewNotSupported}
          move={move}
        />}
      </WebPanel>}
      {externalResourceUrl && <WebPanel isOpen={true} width="1100px" closePanel={() => setExternalResourceUrl(null)} headerText={externalResourceUrl.description} styles={previewWebPanelStyles}>
        <div style={{ height: "calc(100vh - 80px)", width: "100%", marginTop: 5 }}>
          <iframe style={{ height: "100%", width: "100%", border: "none", overflow: "hidden" }} src={externalResourceUrl.url} />
        </div>
      </WebPanel>}
      {showRenameDialog && <CMRenameModal showDialog={showRenameDialog} closeDialog={() => setShowRenameDialog(false)} selectedItem={selectedItem} closeOnSuccess={() => metaDataUpdated(null, null, null)} />}
      {isCMFileInfoPanelOpen && (selectedItem || selectedNewDocumentTemplate) &&
        <CMFileInfoPanel
          // panelIsOpen={isCMFileInfoPanelOpen && (selectedItem || selectedNewDocumentTemplate)}
          panelIsOpen={isCMFileInfoPanelOpen}
          closeOnSuccess={metaDataUpdated}
          closePanel={() => { setIsCMFileInfoPanelOpen(false); setSelectedNewDocumentTemplate(null); }}
          item={selectedItem}
          infoPanelMode={infoPanelMode}
          selectedTemplate={selectedNewDocumentTemplate}
          folderPath={folderPath}
          userPermissions={selectedItem?.EffectiveBasePermissions}
          onItemUpdated={() => itemUpdatedId.current = selectedItem?.ID}
          filePreview={!hideAutoPreview
            && selectedItem
            && !getIsPreviewNotSupported
            && infoPanelMode === InfoPanelMode.Update
            && <CMFilePreviewPanel
              selectedItem={selectedItem}
              searchSource={SearchSource.Sharepoint}
              isInOneDrive={isInOneDrive.current}
              totalItemCount={gridProps?.items?.length}
              selectedItemIndex={getSelectedIndex()}
              previewNotSupported={getIsPreviewNotSupported}
              isPropertiesPreview
              isMoveBackDisabled={getIsMoveBackDisabled()}
              isMoveForwardDisabled={getIsMoveForwardDisabled()}
              move={async (direction: MoveDirection) => {
                if (itemUpdatedId.current === selectedItem?.ID) {
                  await metaDataUpdated(null, null, null, null, null, false);
                }
                else {
                  itemUpdatedId.current = undefined;
                }
                move(direction);
              }}
            />}
        />}
      {!isInOneDrive.current && isCMFileInfoPanelOpen && (selectedItems?.items?.length > 1) && <CMFilesUpdatePanel panelIsOpen={isCMFileInfoPanelOpen && (selectedItems?.items?.length > 1)} closePanel={() => setIsCMFileInfoPanelOpen(false)} reloadGrid={reloadGrid} selectedItems={selectedItems?.items} />}
      {isCMCreateFolderPanelOpen && <NewFolderPanel isOpen={isCMCreateFolderPanelOpen} selectedTemplate={selectedNewDocumentTemplate} dismissNewFolderPanel={() => { setIsCMCreateFolderPanelOpen(false); setSelectedNewDocumentTemplate(null); }} onFolderCreated={onFolderCreated} serverRelPath={serverRelPath} />}
      {isCMCreateLinkPanelOpen && <CMNewLinkPanel panelIsOpen={isCMCreateLinkPanelOpen} closePanel={() => { setIsCMCreateLinkPanelOpen(false); }} reloadGrid={reloadGrid} serverRelPath={serverRelPath} />}
      {isCMUploadFilesPanelOpen && <CMUploadFilesPanel panelIsOpen={isCMUploadFilesPanelOpen} closePanel={() => { setIsCMUploadFilesPanelOpen(false); DragAndDropHelper.reset(); }} reloadGrid={reloadGrid} serverRelPath={serverRelPath} />}
      {isCMFileFilterPanelOpen && <CMFileFilterPanel panelIsOpen={isCMFileFilterPanelOpen} closePanel={() => setIsCMFileFilterPanelOpen(false)} isInOneDrive={isInOneDrive.current} serverRelPath={serverRelPath} selectedView={selectedView} />}
      {isCMFileSharePanelOpen && <CMFileSharePanel panelIsOpen={isCMFileSharePanelOpen} closePanel={() => setIsCMFileSharePanelOpen(false)} items={sharePanelModeRef.current === SharePanelMode.Share ? [selectedItem] : selectedItems?.items} mode={sharePanelModeRef.current} />}
      {showDeleteDialog && <CMDeleteModal showDialog={showDeleteDialog} closeDialog={() => setShowDeleteDialog(false)} selectedItems={selectedItems?.items} closeOnSuccess={onDeleteCloseSuccess} />}
      {showCancelAssignmentDialog && <CMCancelAssignmentModal showDialog={showCancelAssignmentDialog} closeDialog={() => setShowCancelAssignmentDialog(false)} closeOnSuccess={onCancelAssignmentSuccess} selectedItem={selectedItem} />}
      {isCMErrorModalOpen && <CMErrorModal message={errorMessage} showDialog={isCMErrorModalOpen} closeDialog={() => setIsCMErrorModalOpen(false)} />}
      {isCMMoveFilesListPanelOpen && <CMMoveFilesListPanel panelIsOpen={isCMMoveFilesListPanelOpen} closePanel={() => setIsCMMoveFilesListPanelOpen(false)} />}
      {isFileUploadProgressPanelOpen && <CMFileUploadProgressPanel panelIsOpen={isFileUploadProgressPanelOpen} closePanel={() => setIsFileUploadProgressPanelOpen(false)} />}
      {showConfirmMoveToDialog && !moveTo.moveToEnabled && <CMConfirmModal
        title={(moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? languageStrings.MoveItems : languageStrings.CopyItems}
        message={languageStrings.SelectDestinationDirectory}
        showDialog={showConfirmMoveToDialog}
        closeDialog={() => {
          dispatch(setContentManagerMoveTo({
            moveToEnabled: false,
            workingDirectories: [],
            selectedFiles: [],
            siteUrl: "",
            sourceServerRelPath: "",
            progressCountCompleted: 0,
            progressCountTotal: 0
          }));
          setShowConfirmMoveToDialog(false)
        }}
        closeText=""
        confirmText={languageStrings.Ok}
        onConfirm={() => { onConfirmMoveFiles(false) }}
      />}
      {showConfirmMoveToDialog
        && moveTo.moveToEnabled
        && (moveTo.mode === ContentManagerCopyMoveModeEnum.Copy || moveTo.mode === ContentManagerCopyMoveModeEnum.CopyAll || currentDirectory?.id !== moveToDirectory?.id)
        && <CMConfirmModal
          title={`${languageStrings.Confirm} ${(moveTo.mode === ContentManagerCopyMoveModeEnum.Move || moveTo.mode === ContentManagerCopyMoveModeEnum.MoveAll) ? languageStrings.MoveItems : languageStrings.CopyItems}`}
          htmlContent={htmlConfirmMessage}
          showDialog={showConfirmMoveToDialog}
          closeDialog={() => setShowConfirmMoveToDialog(false)}
          closeText={languageStrings.Cancel}
          confirmText={languageStrings.Yes}
          onConfirm={() => { onConfirmMoveFiles(true) }}
          isBusy={isBusyCreatingMoveToJobQue}
        />}
    </>
  )
};